export default "__VITE_ASSET__DEakm7LP__"